export default {
  locales: {
    tat: 'tat',
    rus: 'rus',
    eng: 'eng'
  },
  namespace: 'unistroyrf',
  appShortName: 'ЕХО',
  appLongName: 'Единое хранилище объектов',
  rowsPerPage: 20,
  baseURL: 'https://uos.unistroyrf.ru/api',
  // baseURL: 'http://uni-eho.local/api',
  rowsPerPageItems: [10, 20, 50, 100]
}
